export default function VeritcalColumnUI({ children, heightValue }) {
  return (
    <div
      data-testid="vertical-column-ui"
      className='dark:bg-gray-900 dark:text-white overflow-y-auto'
      style={{
        height: heightValue,
        backgroundColor: '#FFFFFF',
        border: '1px solid #E4E4E7',
        borderRadius: 0,
        padding: '10px',
        color: '#09090B'
      }}
    >{children}</div>
  )
}
